module.exports = __webpack_public_path__ + "media/1_ring_in.846c6751.mp3";